function loadView(view) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

export default [
	{
		path: '',
		name: 'DivisionHome',
		component: loadView('Front/Division/Table')
	},
	{
		path: 'notices',
		name: 'DivisionNotices',
		component: loadView('Front/Division/Notices')
	},
	// {
	// 	path: 'notices/:noticeSlug',
	// 	name: 'DivisionNotice',
	// 	component: loadView('Front/Division/Notice')
	// },
	{
		path: 'teams',
		name: 'DivisionTeams',
		component: loadView('Front/Division/Teams')
	},
	{
		path: 'liguilla',
		name: 'DivisionLiguilla',
		component: loadView('Front/Division/Liguilla')
	},
	{
		path: 'upcoming-matches',
		name: 'DivisionUpcomingMatches',
		component: loadView('Front/Division/UpcomingMatches')
	},
	{
		path: 'the-bests',
		name: 'DivisionBests',
		component: loadView('Front/Division/TheBests')
	},
	{
		path: 'gks',
		name: 'DivisionBestGks',
		component: loadView('Front/Division/Gks')
	},
	{
		path: 'assists',
		name: 'DivisionBestAssists',
		component: loadView('Front/Division/Assists')
	},
	{
		path: 'scorers',
		name: 'DivisionBestScorers',
		component: loadView('Front/Division/Scorers')
	},
	{
		path: 'mvp',
		name: 'DivisionBestMvps',
		component: loadView('Front/Division/Mvps')
	},
	{
		path: 'yellow-cards',
		name: 'DivisionYellowCards',
		component: loadView('Front/Division/YellowCards')
	},
	{
		path: 'red-cards',
		name: 'DivisionRedCards',
		component: loadView('Front/Division/RedCards')
	},
	{
		path: 'team-of-the-week/week-:code',
		name: 'DivisionTeamWeek',
		component: loadView('Front/Division/TeamWeek')
	},
	{
		path: 'champions',
		name: 'DivisionChampions',
		component: loadView('Front/Division/Champions')
	},
	{
		path: 'match/:fixtureId',
		name: 'DivisionMatchDetail',
		component: loadView('Front/Division/MatchDetail')
	},
	{
		path: 'banned',
		name: 'DivisionBanned',
		component: loadView('Front/Division/Banned')
	}
]
